module.exports = __webpack_public_path__ + "img/wx-kefu.990f358c.jpg";